export default "/images/edit-app.png?f9a3b61ed2b2e9a224fc066b488e79c3";